import WalletCards from "./WalletCards";
export default WalletCards;
